import { PropType, computed, defineComponent } from 'vue'

import { CsAccordion, CsDropdown, CsLocationAutocomplete } from '@sunrise/components'
import { LocationAutocomplete } from '@sunrise/types'

import { SearchRequestKeys } from '../../ts/mapper/CmsPropertyMapper.enum'
import { useMailAgentStore } from '../../ts/store/mailAgentStoreModule/mailAgentStoreModule'
import { useResultListStore } from '../../ts/store/resultListStoreModule/resultListStoreModule'
import { updateSearchParams } from '../../ts/utils/searchListUtils'

export default defineComponent({
    name: 'MsFilterLocationArea',
    components: { CsAccordion, CsDropdown, CsLocationAutocomplete },
    props: { locationLevels: { type: Array as PropType<LocationAutocomplete.LOCATION_LEVELS[]>, required: true } },
    setup() {
        const resultListStore = useResultListStore()
        const { tags } = useMailAgentStore()
        const currentLocation = computed(() => resultListStore.selectedLocation)
        const selectedRadius = computed(() => resultListStore.searchParams.sr?.toString() as string)
        const searchRadiusOptions = [
            {
                label: '1 km',
                value: '1',
            },
            {
                label: '2 km',
                value: '2',
            },
            {
                label: '5 km',
                value: '5',
            },
            {
                label: '10 km',
                value: '10',
            },
            {
                label: '20 km',
                value: '20',
            },
            {
                label: '50 km',
                value: '50',
            },
        ]
        const onLocationSelected = (newValue: LocationAutocomplete.locationAutocompleteEmitValue) => {
            resultListStore.resetPage()
            updateSearchParams({
                [SearchRequestKeys.LOCATION]: newValue.location.id,
                [SearchRequestKeys.LATITUDE]: newValue.location.cityCenter?.latitude,
                [SearchRequestKeys.LONGITUDE]: newValue.location.cityCenter?.longitude,
            })

            resultListStore.selectedLocation = newValue.location.name

            tags.locationName = newValue.location.name

            resultListStore.updateHeadline(undefined, newValue.location.name)
        }
        const onRadiusChanged = (newValue: string) => {
            resultListStore.resetPage()
            updateSearchParams({ [SearchRequestKeys.SEARCH_RADIUS]: newValue })

            tags.searchRadius = `Umkreis ${newValue}km`
        }

        return {
            currentLocation,
            selectedRadius,
            searchRadiusOptions,
            onLocationSelected,
            onRadiusChanged,
        }
    },
})
